import React, {useEffect, useState} from "react";
import moment, { months } from "moment";
import ReactApexChart from "react-apexcharts";
import Loading from "../../../components/Loading/LoadingEffect";
import {getProductGraphData} from "../../../controllers/V1/statisticsReports/statisticsReportsController";
const ProductsBarGraph = () => {
  const [isLoading, setIsLoading]= useState(false);
  const [graphType, setGraphType] = useState('bar');

  const [hour, setHour] = useState([]);
  const [count, setCount] = useState([]);
  const [totalSales, setTotalSales] = useState(0);
  const [filter, setFilter] = useState({
    start_date : `${moment().startOf('month').format('YYYY-MM-DD')}`,
    start_time : `21:30:00`,
    end_date : `${moment().endOf('month').format('YYYY-MM-DD')}`,
    end_time : `21:31:00`,
  })

  const getData = async () => {
    setIsLoading(true);
    try {
      const res = await getProductGraphData(filter);
      if(res.status === true){
        if(res.result?.length > 0){  
          let points = 0;
          const hours = [], counts = [], totalSales = [];
          res.result.forEach(item => {
            hours.push(item._id);
            counts.push(item.count);
            const itemPoints = parseFloat(item.total_point) || 0;
            points = itemPoints + points; 
            totalSales.push(points); 
          });
          setHour(hours);
          setCount(counts);
          setTotalSales(points);
        }else{
          setHour(['No order found!']);
          setCount([0]);
          setTotalSales(0);
        }
        
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setHour(['No order found!']);
      setCount([0]);
      setTotalSales(0);
    }
  }

  useEffect(()=>{
    getData();
  },[filter])


  const series = [
    {
      name: "Sales",
      data: count
      // data: graphData[showGraph],
    },
  ];
  const options = {
    chart: {
      height: 350,
      type: graphType,
    },
    xaxis: {
      categories: hour,
    },
  };

  const handleChnage = (e) =>{
    const {name, value}= e.target;
    setFilter((pre)=>({
      ...pre,
      [name] : value
    }))
  }

  return (
    <>
      <div className="inventory_tabs_main_div mt-0">
        <div className="card ">
          <div className="card-header all_border_bottom_for_hide">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">Products's Orders</h5>
              <div className="card-title mb-0">
                <select onChange={(e)=>setGraphType(e.target.value)} className="form-control select_filter_class">
                  <option value={'bar'} >Bricks</option>
                  <option value={'area'}>Wave</option>
                </select>
              </div>
              <div className="card-title mb-0">
                <input type="date" name="start_date" id="start_date" value={filter?.start_date} onChange={handleChnage} className="form-control select_filter_class" />
              </div>
              <div className="card-title mb-0">
                <input type="time" name="start_time" id="start_time" value={filter?.start_time} onChange={handleChnage} className="form-control select_filter_class" />
              </div>
              To
              <div className="card-title mb-0">
                <input type="date" name="end_date" id="end_date" value={filter?.end_date} onChange={handleChnage} className="form-control select_filter_class" />
              </div>
              <div className="card-title mb-0">
                <input type="time" name="end_time" id="end_time" value={filter?.end_time} onChange={handleChnage} className="form-control select_filter_class" />
              </div>
              
            </div>
          </div>
          <div className="card-body">
            <div>
              <ReactApexChart
                options={options}
                series={series}
                type={graphType}
                height={350}
              />
            </div>
          </div>
          <div className="card-header all_border_bottom_for_hide">
            <div className="d-flex justify-content-between align-items-center">
              <button type="button" onClick={()=>{ 
                setFilter((pre)=>({
                  ...pre,
                  start_date : moment(filter?.start_date).subtract(1, 'months').format('YYYY-MM-DD'),
                  end_date : moment(filter?.end_date).subtract(1, 'months').format('YYYY-MM-DD')
                }))
              }
              } className="btn btn-light card-title mb-0">{`<< Pre`}</button>
              <div className="card-title mb-0">
                Total Sales : {totalSales}
              </div>
              <div className="card-title mb-0">
                <button type="button" onClick={()=>{ 
                  setFilter((pre)=>({
                    ...pre,
                    start_date : moment(filter?.start_date).add(1, 'months').format('YYYY-MM-DD'),
                    end_date : moment(filter?.end_date).add(1, 'months').format('YYYY-MM-DD')
                  }))
                 }} className="form-control card-title mb-0">{`Next >>`}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loading isLoading={isLoading} />
    </>
  );
}

export default ProductsBarGraph;
